export default __webpack_public_path__ + "static/media/shadowhex.d99b64ec.png";